import { Logo } from './logo';
import { LogoBordier } from './logoBordier';
import { LogoM2 } from './logoM2';

const THEME = process.env.THEME;

let ExportLogo = Logo;

if (THEME == 'bordier') ExportLogo = LogoBordier;
if (THEME == 'm2') ExportLogo = LogoM2;

export { ExportLogo as Logo };
